<template>
    <div class="amount-sec">
        <div class="withdraw-input-content slct-bank-wrapper p-0">
            <label class="form-label">{{$t('bank-name','Bank Name')}}</label>
            <VueMultiselect
                ref="bankSelect"
                v-model="records.bankId"
                :options="bankDetails"
                :close-on-select="true"
                :clear-on-select="false"
                :placeholder="!records.bankId ? (bankDetails?.length > 0 ? $t('select-bank-name','Select Bank Name') : 'Bank Accounts Not Found') : ''"
                label="bank_name"
                track-by="id"
                @click.stop.prevent="toggleDropdown"
                @select="selectBank"
            >
                <template #noResult>
                    <span class="multiselect__option">{{ $t('no-data-found','No data found!')}}</span>
                </template>
            </VueMultiselect>
            
            <div class="validation-message" v-if="v$.records.bankId.$error">{{$t('please-select-bank-name.','Please Select Bank Name')}}</div>
        </div>
        <div class="withdraw-input-content">
            <label class="form-label">{{$t('account-holder-name','Account holder’s name')}}* </label>
            <input type="text" v-model="records.account_holder_name" @input="senitizeHolderName" :placeholder="$t('please-enter-account-holder-name','Enter Account Holder Name')" class="enter-amount-box">
            <span class="validation-message" v-if="v$.records.account_holder_name.$error">
                <template v-if="v$.records.account_holder_name.required.$invalid">
                    {{$t('account-holder-name-is-required','Account holder name is required.')}}
                </template>
                <template v-else-if="v$.records.account_holder_name.minLength.$invalid || v$.records.account_holder_name.maxLength.$invalid">
                    {{$t('account-holder-name-must-be-3-100-characters','Account holder name must be 3-100 characters.')}}
                </template>
                <template v-if="v$.records.account_holder_name.alphaName.$invalid">
                    {{$t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.')}}
                </template>
            </span>
        </div>
        <div class="withdraw-input-content">
            <label class="form-label">{{$t('account-number','Account number')}}* </label>
            <input type="tel" maxlength="25" v-model="records.account_no" :placeholder="$t('please-enter-account-number','Enter Account Number')" class="enter-amount-box">
           <span class="validation-message" v-if="v$.records.account_no.$error">
                <template v-if="v$.records.account_no.required.$invalid">
                    {{$t('please-enter-account-number','Account number is required.')}}
                </template>
                <template v-else-if="v$.records.account_no.accountNoValidator.$invalid">
                    {{$t('account-number-must-be-valid-numeric-value-between-9-to-18-digits','Account number must be valid numeric value between 9 to 18 digits.')}}
                </template>
            </span>
        </div>
        <div class="withdraw-input-content">
            <label class="form-label">{{$t('ifsc-code','IFSC Code')}}* </label>
            <input type="text" maxlength="15" v-model="records.ifsc_code" @input="records.ifsc_code = records.ifsc_code.toUpperCase()" :placeholder="$t('enter-ifsc-code','Enter IFSC Code.')" class="enter-amount-box">
            <span class="validation-message" v-if="v$.records.ifsc_code.$error">
                <template v-if="v$.records.ifsc_code.required.$invalid">
                    {{$t('ifsc-code-is-required','IFSC Code is required')}}
                </template>
                <template v-else-if="v$.records.ifsc_code.ifscValidator.$invalid">
                    {{$t('isfc-11-code','IFSC should be 11 alphanumeric characters.')}}
                </template>
            </span>
        </div>
        <div v-if="!is2faEnabled" class="cmn_withdraw_cl position-relative withdraw-input-content">
            <label class="form-label">{{$t('withDraw-password','Withdraw Password')}}* </label>
            <input :type="isPassVisible ? 'text' : 'password'" v-model="records.withdrawal_password" :placeholder="$t('enter-withdraw-password','Enter Withdraw Password')" class="enter-amount-box">
            <i @click="isPassVisible = !isPassVisible"  
                :class="['fas', 'togglePassword', 'toggle-withdraw-pass', !isPassVisible ? 'fa-eye-slash' : 'fa-eye']">
            </i>
            <div class="validation-message" v-if="v$.records?.withdrawal_password?.$error">{{$t('please-enter-withdraw-password','Please Enter Withdraw Password')}}</div>
        </div>
        <div v-else class="cmn_withdraw_cl position-relative withdraw-input-content">
            <label class="form-label">{{$t('authentication-code','Authentication Code')}}* 
                <span class="info-sec-icon">
                    <img src="@/assets/images/info-icon.svg" alt="info-icon" loading="lazy" />
                    <div class="info-list info-main">
                        <ul>
                            <li>{{$t('enter-authentication-code-from-authenticator-app' , authenticationCodeInputInfo)}}</li>
                        </ul>
                    </div>
                </span>
            </label>
            <input  v-model="records.otp" maxlength="6" minlength="6" :placeholder="$t('enter-authentication-code','Enter Authentication Code')" class="enter-amount-box" @input="records.otp = $helper.sanitizeNumber(records.otp,999999);">
            <div v-if="v$.records.otp.$error">
                <div class="validation-message" v-if="v$.records.otp.required.$invalid">
                    {{ $t('authentication-code-required', 'Authentication Code is Required') }}
                </div>
                <div class="validation-message" v-else-if="v$.records.otp.minLength.$invalid || v$.records.otp.maxLength.$invalid">
                    {{ $t('authentication-code-6-digit', 'Authentication Code must be 6 digits') }}
                </div>
            </div>      
        </div>
        <div class="withdraw-input-content">
            <div class="rules-button">
                <div class="rulesAccept">
                    <div class="form-check">
                        <input class="form-check-input" v-model="records.termCondition" type="checkbox" value=""
                            id="consolidate">
                            <div class="validation-message" v-if="v$.records.termCondition.$error">{{$t('please-accept-terms-and-condiotion','Please Accept Terms And Condition')}}</div>
                        <label class="form-check-label">
                            <span class="rulesAccept__text">{{$t('i-have-read-and-agree-with','I have read and agree with')}}&nbsp;
                                <a href="#payment-policy" data-bs-toggle="modal" class="rulesAccept__text-underline">the terms of
                                    {{$t('the-terms-of-payment-and-withdrawal-policy','the terms of payment and withdrawal policy.')}}</a>
                            </span>
                        </label>
                    </div>
                </div>
                <div class="proceed-btn">
                    <button type="button" @click="proceedHandler">{{$t('proceed','Proceed')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { required, minLength, maxLength, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core';
import VueMultiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import { authenticationCodeInputInfo } from '@template/utils';
const alphaName = helpers.withMessage(
  'Must contain only alphabets, spaces, dots, or hyphens.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    const s = String(value)
    return /^[A-Za-z .-]+$/.test(s)
  }
)
const accountNoValidator = helpers.withMessage(
  'Account number must be valid numeric value between 9 to 18 digits.',
  (value) => {
    if (!value) return true
    return /^[0-9]{9,18}$/.test(String(value))
  }
)
const ifscValidator = helpers.withMessage(
  "IFSC should be 11 alphanumeric characters.",
  (value) => {
    if (!value) return true
    return /^[a-zA-Z0-9]{11}$/.test(String(value))
  }
)
export default {
    name: 'CreateAccount',
    props:['bankDetails', 'records','is2faEnabled'],
    setup() {
		return { v$: useVuelidate() }
	},
    data() {
        return {
            isPassVisible: false,
            toggleDropDown:false,
            authenticationCodeInputInfo
        }
    },
    computed: {
        ...mapGetters(['userBonus']),
        withdrawlBalance() {
            let { balance = 0, expl = 0 } = this.$auth?.user || {};
            let earnBonus = this.$store.getters?.userBonus?.earnBonus || 0;
            return (parseFloat(balance) + parseFloat(expl || 0) - parseFloat(earnBonus)).toFixed(2);
        }
    },
    components: {
        VueMultiselect
    },
    validations() {
        return{
        records: {
            // amount: { required },
            bankId: { required },
            account_holder_name: {
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(100),
                    alphaName
                },
             account_no: {
                    required,
                    accountNoValidator
                },
            ifsc_code: {
                    required,
                    ifscValidator
                },
            withdrawal_password: this.is2faEnabled ? {} : { required },
			otp: this.is2faEnabled ? {
                required,
                minLength: minLength(6),
                maxLength: maxLength(6)
			}:{},
            termCondition: { required },
        },
    };
    },
    methods:{
        toggleDropdown() {
            const select = this.$refs.bankSelect
            this.toggleDropDown = !this.toggleDropDown
            if (this.toggleDropDown) {
                select.activate() 
            } else {
                select.deactivate()
            }
        },
        selectBank(item){
            this.records.method_id = item.id
        },
        async proceedHandler() {
        const isValid = await this.v$.$validate();

        if (isValid) {
            if (!this.records.termCondition) {
                this.records.termCondition = true;
                const finalCheck = await this.v$.$validate();
                if (finalCheck) {
                    this.$emit('createAccount');
                }
            } else {
                this.$emit('createAccount');
            }
        }
    }
    }
}
</script>

<style scoped>
.toggle-withdraw-pass {
    top: unset;
    bottom: 11px;
    right: 1rem;
    color: #333;
}
</style>
<style>
.multiselect__single {
    position: relative;
    top: 12px;
    left: 15px;
    color: #000;
}

.multiselect__placeholder {
    display: none;
}
.select-bank{
    position: absolute;
    margin-top: 50px;
}
.withdraw-input-content .multiselect__element .multiselect__option, 
.withdraw-input-content .multiselect__element .multiselect__option span {
    display: inline-block;
    width: 100%;
}
</style>